import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import Button from '../Globle/Button';
import { FiPlus } from 'react-icons/fi';
import { useMainContext } from '../../hooks/useMainContext';
import { PageTypes } from '../../config';

const HomeTab = observer(() => {
    const { viewManager } = useMainContext();
    const [activeTab, setActiveTab] = useState('1');
    const tabButton = [
        {
            title: 'Your Projects',
            isActive: true,
            count: 28,
            key: '1',
        },
        {
            title: 'Your Quotes',
            isActive: false,
            count: 28,
            key: '2',
        },
    ];
    return (
        <div className="flex items-center justify-between">
            <div className="flex  min-w-[845px]">
                {tabButton.map((item, index) => (
                    <React.Fragment key={item.key}>
                        <button
                            onClick={() => setActiveTab(item.key)}
                            className={`home-tab ${activeTab === item.key ? 'active-home-tab' : ''}`}>
                            {item.title}
                            <div>{item.count}</div>
                        </button>
                        {index < tabButton.length - 1 && (
                            <div className="w-[24px] border-b-[2px] border-theme-border"></div> // <-- gap div
                        )}
                    </React.Fragment>
                ))}
                <div className="flex-1 border-b-[2px] border-theme-border"></div>
            </div>
            <Button
                onClick={() => {
                    viewManager.setCurrentPage(PageTypes.WorkSpace);
                }}
                label="New Project"
                icon={FiPlus}
                className="bg-theme-orange text-theme-white hover:bg-theme-orange-hover"
            />
        </div>
    );
});

export default HomeTab;
